import type { Timeframe } from '@/types'
import { TIMEFRAMES } from '@/types'

interface TimeframeSelectorProps {
  value: Timeframe
  onChange: (timeframe: Timeframe) => void
}

export function TimeframeSelector({ value, onChange }: TimeframeSelectorProps) {
  return (
    <div className="flex items-center gap-1 bg-chart-grid rounded-lg p-1">
      {TIMEFRAMES.map(({ value: tf, label }) => (
        <button
          key={tf}
          onClick={() => onChange(tf)}
          className={`
            px-3 py-1.5 rounded text-sm font-medium transition-colors
            ${
              value === tf
                ? 'bg-blue-500 text-white'
                : 'text-text-secondary hover:text-text-primary hover:bg-chart-bg'
            }
          `}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default TimeframeSelector
